export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const ADD_RULE = "ADD_RULE";
export const REMOVE_RULE = "REMOVE_RULE";
export const UPDATE_NODE = "UPDATE_NODE";
export const REMOVE_GROUP_RULE = "REMOVE_GROUP_RULE";
export const ADD_GROUP_RULE = "ADD_GROUP_RULE";
export const TRANSFORM_RULE_TO_OR_GROUP = "TRANSFORM_RULE_TO_OR_GROUP";
export const ADD_AND_RULE = "ADD_AND_RULE";
export const REMOVE_RULE_FROM_AND_GROUP = "REMOVE_RULE_FROM_AND_GROUP";
